<div class="map-control-button-container"
     [class.simple-search-container]="!fullScreen()"
     [class.simple-search-container--is-active]="active() && !fullScreen()"
     [class.simple-search-container--full-screen]="fullScreen()"
     [class.no-transition]="disableTransition()"
     (keyup.escape)="toggle(true)">

  <div class="button-and-form-field">
    <button mat-flat-button
            class="map-control-button"
            [class.toggle-button--active]="active()"
            [tmTooltip]="label"
            (click)="toggle()">
      <mat-icon [svgIcon]="fullScreen() ? 'close' : 'search'"></mat-icon>
    </button>

    @if (active()) {
      <div class="simple-search-field-wrapper">
        @if (isMobile()) {
          <div class="mobile-search-field">
            <input type="text"
                   tmAutoFocus
                   class="mobile-search-field-input"
                   (keydown.enter)="search()"
                   [placeholder]="label"
                   [value]="displayLabel(searchControl.value)"
                   (input)="searchControl.setValue($any($event.target).value)">
          </div>
        } @else {
          <mat-form-field appearance="outline">
            <mat-label>{{label}}</mat-label>
            <input matInput
                   type="text"
                   tmAutoFocus
                   class="search-field"
                   (keydown.enter)="search()"
                   [placeholder]="label"
                   [formControl]="searchControl"
                   [matAutocomplete]="auto" />
            <mat-autocomplete autoActiveFirstOption
                              class="search-panel"
                              (opened)="panelOpen(true)"
                              (closed)="panelOpen(false)"
                              #auto="matAutocomplete"
                              [displayWith]="displayLabel">
              @if (searchResults$ | async; as searchResults) {
                @if (searchResults.length > 1) {
                  <div class="result-summary">
                    @for (searchResult of searchResults; track searchResult.id) {
                      <a href="" (pointerdown)="scrollTo($event, searchResult.id)" (click)="scrollTo($event, searchResult.id)">{{ searchResult.name}} ({{searchResult.results.length}})</a>
                    }
                  </div>
                }
              }
              @if (searchStatus(); as searchStatus) {
                @if (searchStatus === 'belowMinLength') {
                  <mat-option disabled
                              class="hint"
                              i18n="@@core.toolbar.type-at-least">Type at least {{ minLength }} characters to start searching or press &lt;Enter&gt;</mat-option>
                }
                @if (searchStatus === 'no_results') {
                  <mat-option disabled class="hint" i18n="@@core.toolbar.no-results-found">No results found</mat-option>
                }
                @if (searchStatus === 'searching') {
                  <mat-option disabled class="hint">
                    <mat-spinner color="primary" mode="indeterminate" diameter="20"></mat-spinner>
                  </mat-option>
                }
              }
              @if (searchResults$ | async; as searchResults) {
                @for (searchResult of searchResults; track searchResult.id) {
                  @if (searchResult && searchResult.results.length > 0) {
                    <mat-optgroup class="section-label" [id]="'search-group-' + searchResult.id">
                      <h2 class="section-label__heading">
                        {{ searchResult.name }}
                      </h2>
                      @for(option of searchResult.results; track option.id) {
                        <mat-option [value]="option">{{option.label}}</mat-option>
                      }
                      @if (searchResult.attribution) {
                        <mat-option class="attribution" disabled [innerHTML]="searchResult.attribution | htmlify"></mat-option>
                      }
                    </mat-optgroup>
                  }
                }
              }
            </mat-autocomplete>
          </mat-form-field>
        }
      </div>
    }
  </div>

  @if (fullScreen()) {
    <div class="mobile-search-results search-panel">
      @if (searchResults$ | async; as searchResults) {
        @if (searchResults.length > 1) {
          <div class="result-summary">
            @for (searchResult of searchResults; track searchResult.id) {
              <a href="" (pointerdown)="scrollTo($event, searchResult.id)" (click)="scrollTo($event, searchResult.id)">{{ searchResult.name}} ({{searchResult.results.length}})</a>
            }
          </div>
        }
      }
      @if (searchStatus(); as searchStatus) {
        @if (searchStatus === 'belowMinLength') {
          <mat-option disabled
                      class="hint"
                      i18n="@@core.toolbar.type-at-least">Type at least {{ minLength }} characters to start searching or press &lt;Enter&gt;</mat-option>
        }
        @if (searchStatus === 'no_results') {
          <mat-option disabled class="hint" i18n="@@core.toolbar.no-results-found">No results found</mat-option>
        }
        @if (searchStatus === 'searching') {
          <mat-option disabled class="hint">
            <mat-spinner color="primary" mode="indeterminate" diameter="20"></mat-spinner>
          </mat-option>
        }
      }
      @if (searchResults$ | async; as searchResults) {
        @for (searchResult of searchResults; track searchResult.id) {
          @if (searchResult && searchResult.results.length > 0) {
            <mat-optgroup class="section-label" [label]="searchResult.name" [id]="'search-group-' + searchResult.id">
              @for(option of searchResult.results; track option.id) {
                <mat-option [value]="option" (click)="searchControl.setValue(option)">{{option.label}}</mat-option>
              }
              @if (searchResult.attribution) {
                <mat-option class="attribution" disabled [innerHTML]="searchResult.attribution | htmlify"></mat-option>
              }
            </mat-optgroup>
          }
        }
      }
    </div>
  }

</div>
